import Axios, { REQUEST_METHOD } from "../axios";

export async function apiGetBrandAmbassadorBySourceId(userId) {
  return Axios.fetch({
    url: `/ambassador/source/${userId}`, // Endpoint that returns an array of BrandAmbassador records
    method: REQUEST_METHOD.GET,
  }).catch((error) => {
    console.error("Error fetching ambassador by sourceId:", error);
    throw error;
  });
}

export async function apiGetSchedulePerformance(ambassadorId) {
  return Axios.fetch({
    url: `/ambassador/schedule-performance/${ambassadorId}`, // Endpoint for performance data
    method: REQUEST_METHOD.GET,
  }).catch((error) => {
    console.error("Error fetching schedule performance:", error);
    throw error;
  });
}


export async function apiGetAmbassadorLast30WorkedStanding(userId) {
  return Axios.fetch({
    url: `/ambassador/standing-history/${userId}`,
    method: REQUEST_METHOD.GET,
  }).catch((error) => {
    console.error("Error fetching ambassador standing history:", error);
    throw error;
  });
}
export function apiGetBrandAmbassadorEvents(userId) {
  return Axios.fetch({
    url: `/ambassador/events/${encodeURIComponent(userId)}`,
    method: REQUEST_METHOD.GET,
  });
}

export async function apiGetOfferSchedules(userId, role) {
  return Axios.fetch({
    url: `/ambassador/get-offer-schedules/${userId}?role=${encodeURIComponent(role)}`,
    method: REQUEST_METHOD.GET,
  }).catch((error) => {
    console.error("Error fetching offer schedules:", error);
    throw error;
  });
}

export function apiAcceptOffer(offerId, data) {
  return Axios.fetch({
    url: `/ambassador/accept-offer/${offerId}`,
    method: REQUEST_METHOD.POST,
    data,
  });
}

/**
 * Tell the server to drop a shift for the current user.
 * @param {string} brandAmbassadorEventId
 * @param {string} sourceId
 */

// api/backend/brandAmbassador.js
export async function apiDropCurrentUserBrandAmbassadorShift(
  brandAmbassadorEventId
) {
  return Axios.fetch({
    url: `/ambassador/drop-shift`,
    method: REQUEST_METHOD.DELETE,
    data: { brandAmbassadorEventId },
  });
}
/**
 * Fetch all standing history for this brand ambassador (last 30 days).
 */
export async function apiGetStandingMetrics(userId) {
  return Axios.fetch({
    url: `/ambassador/get-brand-ambassador-standing-metrics/${userId}`,
    method: REQUEST_METHOD.GET,
  });
}

export async function apiSubmitStandingMetrics(entries) {
  return Axios.fetch({
    url: `/ambassador/submit-standing-metrics`,
    method: REQUEST_METHOD.POST,
    data: { entries },
  });
}

export async function apiFetchFieldLeaderSchedules(userId) {
  return Axios.fetch({
    url: `/ambassador/field-leader-schedules/${userId}`,
    method: REQUEST_METHOD.GET,
  })
    .then((res) => res) // res === { role, schedules }
    .catch((err) => {
      console.error("Error fetching field‑leader schedules:", err);
      throw err;
    });
}

export async function apiFetchBrandAmbassadorSchedules(userId) {
  return Axios.fetch({
    url: `/ambassador/schedules/${userId}`,
    method: REQUEST_METHOD.GET,
  })
    .then((res) => res) // res === { role, schedules }
    .catch((error) => {
      console.error("Error fetching ambassador schedules:", error);
      throw error;
    });
}

export async function apiFetchAmbassadorLatestPerformance(userId) {
  return Axios.fetch({
    url: `/ambassador/source/${encodeURIComponent(userId)}/fetch-ambassador-latest-performance`,
    method: REQUEST_METHOD.GET,
  })
    .then((res) => res)
    .catch((error) => {
      console.error(
        "Error fetching ambassador latest performance:",
        error
      );
      throw error;
    });
}
// to do for protected branches and notifications check
// protected branches and checks notifications
export default {
  apiFetchAmbassadorLatestPerformance,
  apiGetBrandAmbassadorEvents,
  apiFetchFieldLeaderSchedules,
  apiGetStandingMetrics,
  apiDropCurrentUserBrandAmbassadorShift,
  apiFetchBrandAmbassadorSchedules,
  apiGetBrandAmbassadorBySourceId,
  apiGetSchedulePerformance,
  apiGetAmbassadorLast30WorkedStanding,
  apiGetOfferSchedules,
  apiAcceptOffer,
};
